<app-modal-container
  [title]="task.name"
  (dismissModal)="closeModal()"
  [showFooter]="true"
>
  <div footer>
    <div class="d-flex justify-content-end gap-2">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="closeModal()"
        [disabled]="isSaving"
      >
        Annuler
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="updateTask()"
        [disabled]="isSaving || !editForm.valid"
      >
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        Mettre à jour
      </button>
    </div>
  </div>
  <div body>
    <form [formGroup]="editForm" (ngSubmit)="updateTask()">
      <div class="card">
        <div class="card-body">
          <div class="row g-3">
            <!-- Titre -->
            <div class="col-12">
              <label class="form-label">
                Titre
                <span *ngIf="isFieldDisabled('name')" class="text-muted"></span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="name"
                placeholder="Nom de la tâche"
                maxlength="150"
                [readonly]="isFieldReadonly('name')"
              />
              <div
                *ngIf="submitted && editForm.get('name')?.hasError('required')"
                class="text-danger"
              >
                {{ "taskDescriptionModal.requierd" | translate }}
              </div>
              <div
                *ngIf="submitted && editForm.get('name')?.hasError('maxlength')"
                class="text-danger"
              >
                {{ "taskDescriptionModal.maxlength" | translate }}
              </div>
            </div>

            <!-- Millésime -->
            <div class="col-6">
              <label class="form-label">
                Millésime *
                <span *ngIf="isFieldDisabled('millesime')" class="text-muted"></span>
              </label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">{{ millesimeDayAndMonth }}</span>
                </div>
                <select 
                  class="form-control" 
                  formControlName="millesime" 
                  id="millesime"
                  [disabled]="isFieldDisabled('millesime')"
                >
                  <option value="">{{ "addPlanningTaskModalComponent.choose" | translate }}</option>
                  <option
                    *ngFor="let year of listYear"
                    [value]="year + '-' + (millesimeDayAndMonth.split('/')[1]) + '-' + (millesimeDayAndMonth.split('/')[0])"
                  >
                    {{ year }}
                  </option>
                </select>
              </div>
              <div *ngIf="submitted && editForm.get('millesime')?.hasError('required')" class="text-danger">
                {{ "taskDescriptionModal.requierd" | translate }}
              </div>
            </div>

            <!-- Échéance -->
            <div class="col-6">
              <label class="form-label">
                {{ "taskDescriptionModal.deadline" | translate }} *
                <span *ngIf="isDueDateDayOnly()" class="text-muted">(Jour seulement)</span>
                <span *ngIf="isDueDateDayAndMonthOnly()" class="text-muted">(Jour et mois)</span>
              </label>
              
              @if (isDueDateDayAndMonthOnly()) {
                <!-- Champ jour et mois pour WORKFLOW et OBLIGATION sur "suivi d'échéances" -->
                <div class="input-group">
                  <select 
                    class="form-select" 
                    (change)="onDayChangeForDayAndMonth($event)"
                  >
                    <option *ngFor="let day of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]" 
                            [value]="day"
                            [selected]="day === getDueDateDay()">
                      {{ day }}
                    </option>
                  </select>
                  <select 
                    class="form-select" 
                    (change)="onMonthChangeForDayAndMonth($event)"
                  >
                    <option *ngFor="let month of getMonthsList()" 
                            [value]="month.value"
                            [selected]="month.value === getDueDateMonth()">
                      {{ month.value }}
                    </option>
                  </select>
                  <select 
                    class="form-select" 
                    disabled
                  >
                    <option [selected]="true">
                      {{ getDueDateYear() }}
                    </option>
                  </select>
                </div>
              } @else if (isDueDateDayOnly()) {
                <!-- Champ jour seulement pour WORKFLOW et OBLIGATION -->
                <div class="input-group">
                  <select 
                    class="form-select" 
                    (change)="onDayChange($event)"
                  >
                    <option *ngFor="let day of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]" 
                            [value]="day"
                            [selected]="day === getDueDateDay()">
                      {{ day }}
                    </option>
                  </select>
                  <span class="input-group-text">{{ getDueDateMonth() }}/{{ getDueDateYear() }}</span>
                </div>
              } @else {
                <!-- Champ date complet pour TASK -->
                <div class="input-group input-group-sm">
                  <input
                    class="form-control"
                    formControlName="dueDate"
                    ngbDatepicker
                    #d="ngbDatepicker"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-secondary"
                      type="button"
                      (click)="d.toggle()"
                    >
                      <i class="fas fa-calendar-alt"></i>
                    </button>
                  </div>
                </div>
              }
              
              <div
                *ngIf="submitted && editForm.get('dueDate')?.hasError('required')"
                class="text-danger"
              >
                {{ "taskDescriptionModal.requierd" | translate }}
              </div>
            </div>

            <div class="col-6">
              <label class="form-label">Assigné à *</label>
              <app-dropdown-select
                apiUrl="user_firms"
                [apiFilters]="{ 'userInfo.isEnabled': true }"
                formControlName="executor"
                [isMultiSelect]="false"
                [itemsPerPage]="100"
                [placeHolder]="'taskDescriptionModal.assignedToUserPlaceholder' | translate"
                [itemValueKey]="'user'"
                [itemLabelKey]="'fullName'"
                [searchKey]="'user.fullName'"
              ></app-dropdown-select>
              <div
                *ngIf="submitted && editForm.get('executor')?.hasError('required')"
                class="text-danger"
              >
                {{ "taskDescriptionModal.requierd" | translate }}
              </div>
            </div>

            <div class="col-6">
              <label class="form-label">{{ getDateLabel() }} *</label>
              <div class="input-group input-group-sm">
                <input
                  class="form-control"
                  formControlName="plannedDate"
                  ngbDatepicker
                  #plannedDatePicker="ngbDatepicker"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-secondary"
                    type="button"
                    (click)="plannedDatePicker.toggle()"
                  >
                    <i class="fas fa-calendar-alt"></i>
                  </button>
                </div>
              </div>
              <div
                *ngIf="submitted && editForm.get('plannedDate')?.hasError('required')"
                class="text-danger"
              >
                {{ "taskDescriptionModal.requierd" | translate }}
              </div>
            </div>

            <!-- Priorité -->
            <div class="col-6">
              <label class="form-label">
                {{ "taskDescriptionModal.priority.title" | translate }}
              </label>
              <select class="form-select" formControlName="priority">
                <option [value]="2">P1</option>
                <option [value]="1">P2</option>
                <option [value]="0">P3</option>
                <option [value]="3">P4</option>
                <option [value]="4">P5</option>
              </select>
            </div>

            <div class="col-6">
              <label class="form-label">Temps (heure) *</label>
              <input
                type="text"
                inputmode="decimal"
                class="form-control"
                formControlName="initialDuration"
              />
              <div
                *ngIf="submitted && editForm.get('initialDuration')?.hasError('required')"
                class="text-danger"
              >
                {{ "taskDescriptionModal.requierd" | translate }}
              </div>
            </div>

            <!-- Catégories -->
            <div class="col-6">
              <label class="form-label">
                {{ "taskDescriptionModal.category" | translate }}
                <span *ngIf="isFieldDisabled('category')" class="text-muted"></span>
              </label>
              <app-dropdown-select
                formControlName="category"
                [apiUrl]="'categories'"
                [apiFilters]="{ 'order[filter]': 'ASC' }"
                [isMultiSelect]="false"
                [itemsPerPage]="100"
                [placeHolder]="'addPlanningTaskModalComponent.categoryPlaceholder' | translate"
                [itemValueKey]="'@id'"
                [itemLabelKey]="'name'"
                [searchKey]="'name'"
                [disabled]="isFieldDisabled('category')"
              ></app-dropdown-select>
            </div>

            <!-- Description -->
            <div class="col-12">
              <label class="form-label">
                {{ "taskDescriptionModal.description" | translate }}
              </label>
              <textarea
                class="form-control"
                rows="4"
                formControlName="description"
                placeholder="{{ 'taskDescriptionModal.taskDescriptionPlaceholder' | translate }}"
              ></textarea>
            </div>

            <!-- Type de facturation -->
            <div class="col-6">
              <label class="form-label">
                {{ "taskDescriptionModal.billingType.title" | translate }}
              </label>
              <select class="form-select" formControlName="billingType">
                <option value="">
                  {{ "taskDescriptionModal.choose" | translate }}
                </option>
                <option [value]="'BILLABLE'">
                  {{ "taskDescriptionModal.billingType.BILLABLE" | translate }}
                </option>
                <option [value]="'PAID'">
                  {{ "taskDescriptionModal.billingType.PAID" | translate }}
                </option>
                <option [value]="'INTERNAL'">
                  {{ "taskDescriptionModal.billingType.INTERNAL" | translate }}
                </option>
                <option [value]="'FREE'">
                  {{ "taskDescriptionModal.billingType.FREE" | translate }}
                </option>
              </select>
            </div>

            <!-- Montant -->
            <div class="col-6" *ngIf="showAmountField()">
              <label class="form-label">
                {{ "taskDescriptionModal.amount" | translate }}
              </label>
              <input
                type="number"
                class="form-control"
                formControlName="amount"
                min="0"
                step="0.01"
              />
            </div>

            <div class="col-6" *ngIf="!showAmountField()"></div>

            <ng-container *ngIf="showFiscalFields()">
              <div class="col-6">
                <label class="form-label">
                  {{ "taskDescriptionModal.fiscalPaymentMode" | translate }}
                </label>
                <app-dropdown-select
                  formControlName="fiscalPaymentMode"
                  [apiUrl]="'fiscal_payment_modes'"
                  [apiFilters]="{ 'order[filter]': 'ASC' }"
                  [isMultiSelect]="false"
                  [itemsPerPage]="100"
                  [placeHolder]="'taskDescriptionModal.choose' | translate"
                  [itemValueKey]="'@id'"
                  [itemLabelKey]="'name'"
                  [searchKey]="'name'"
                  [disabled]="isFieldDisabled('fiscalPaymentMode')"
                ></app-dropdown-select>
              </div>
              <div class="col-6">
                <label class="form-label">
                  {{ "taskDescriptionModal.amountFiscal" | translate }}
                </label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="amountFiscal"
                  min="0"
                  step="0.01"
                  [readonly]="isFieldReadonly('amountFiscal')"
                />
              </div>
              <div class="col-12" *ngIf="task.fiscalPaymentStatus as fps">
                <label class="form-label d-block">
                  {{ "taskDescriptionModal.fiscalPaymentStatus" | translate }}
                </label>
                <span
                  class="badge rounded-pill px-3 py-2"
                  [style.background-color]="fps.color || '#6c757d'"
                  style="color: #fff"
                  >{{ fps.name }}</span
                >
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Loader -->
      <div *ngIf="isSaving" class="text-center my-2">
        <span
          class="spinner-border spinner-border-sm text-primary"
          role="status"
          aria-hidden="true"
        ></span>
        <span class="ms-2">{{ "cardForm.saving" | translate }}</span>
      </div>
    </form>
  </div>
</app-modal-container>
